import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Layout from './Layout/Layout';
import './HomePage.css';

const ContinentView = ({ continentName, bannerImage, description, destinations }) => {
  const navigate = useNavigate();

  const handleDestinationClick = (region) => {
    navigate('/region', { state: { region: region } });
  };

  return (
    <Layout>
      <Helmet>
        <title>{`${continentName} Travel Guide | The Half Time Travel`}</title>
        <meta name="description" content={description || `Explore ${continentName} travel destinations, itineraries, and family adventures with The Half Time Travel.`} />
        <meta property="og:title" content={`${continentName} Travel Guide | The Half Time Travel`} />
        <meta property="og:description" content={description} />
        {bannerImage && <meta property="og:image" content={bannerImage} />}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "TravelBlog",
            "name": `The Half Time Travel - ${continentName}`,
            "description": description,
            "url": `https://www.thehalftimewhistle.com/${continentName.toLowerCase().replace(/\s+/g, '')}`
          })}
        </script>
      </Helmet>

      <div className="home-page">
        <header className="header">
          <div className="banner">
            {bannerImage && (
              <img src={bannerImage} alt={`${continentName} Banner`} className="banner-image" loading="lazy" />
            )}
            <h1 className="banner-text">Welcome to The Half Time Travel {continentName} Page</h1>
          </div>
        </header>

        <main className="main-content" style={{ padding: '20px' }}>
          <section className="content-blocks">
            {destinations && destinations.map((dest) => (
              <article
                key={dest.name}
                className="block"
                onClick={() => handleDestinationClick(dest.region || dest.name)}
              >
                <div className="block-content">
                  <img
                    src={dest.image}
                    alt={`${dest.name} Travel`}
                    loading="lazy"
                    onError={(e) => {
                      // Fallback if CDN path extension differs
                      if (bannerImage) {
                        e.target.src = bannerImage;
                      }
                    }}
                  />
                  <h2>{dest.name}</h2>
                </div>
              </article>
            ))}
          </section>
        </main>
      </div>
    </Layout>
  );
};

export default ContinentView;
